class SiteLoader
    extends QueryElement<HTMLElement> {

    private calls: number;
    private timer?: number;

    constructor() {
        super(document.createElement("div"));
        this.addClass("loader");

        this.calls = 0;

        this.setHtml(`
        <div>
            <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="6" stroke-miterlimit="10"/>
            </svg>
        </div>`)
    }

    show() {
        this.calls++;
        if (this.timer != null)
            clearTimeout(this.timer);
        
        this.timer = setTimeout(() => this.showHide(), 700);
    }
    hide() {
        this.calls--;
        this.showHide();
    }

    private showHide() {
        if(this.isRemoved())
            return;
        
        if (this.calls == 0)
            this.addClass("hide");
        else
            this.removeClass("hide");
    }
}  